import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Styles from './PlusIcon.styles';

const Wrapper = styled.div`${Styles.wrapper}`; // prettier-ignore
const HorizontalLine = styled.div`${Styles.horizontalLine}`; // prettier-ignore
const VerticalLine = styled.div`${Styles.verticalLine}`; // prettier-ignore

/**
 * PlusIcon component
 * @param {boolean} prop.isActive - display the minus icon when its true
 * @returns {JSX}
 */
const PlusIcon = ({ isActive, onClick }) => (
  <Wrapper isActive={isActive} onClick={onClick}>
    <HorizontalLine isActive={isActive} />
    <VerticalLine isActive={isActive} />
  </Wrapper>
);

PlusIcon.propTypes = {
  isActive: PropTypes.bool,
  onClick: PropTypes.func
};

export default PlusIcon;
